
import { mapGetters } from 'vuex'
export default {
  props: {
    canUserBuyWithSubscription: {
      type: Boolean,
      default: false,
    },
    subscriptions: {
      type: Array,
      default: () => [],
    },
    productType: {
      type: Number,
      default: 0,
    },
    productId: {
      type: Number,
      default: 0,
    },
    orHidden: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      getUserSubscriptions: 'user/getUserSubscriptions',
    }),
  },
  data() {
    return {
      isLoading: false,
    }
  },
  methods: {
    handleBuyWithSubscription() {
      document
        .getElementById('subscription-packages')
        .scrollIntoView({ behavior: 'smooth' })
    },
    async handleActivateWithSubscription() {
      if (!this.productId || !this.productType) {
        console.error('ProductId ve ProductType gerekli')
        return
      }

      this.isLoading = true
      const subscription = this.getUserSubscriptions.find((s) =>
        this.subscriptions.some((sp) => sp.id === s.subscriptionPackageId)
      )
      if (!subscription) {
        alert('Abonelik paketi bulunamadı')
        return
      }
      try {
        console.log(subscription, 'subscription')
        const response = await this.$api.post('Products/BuyBySubscription', {
          productId: this.productId,
          productType: this.productType,
          subscriptionId: subscription.id,
        })

        if (response?.message === 'OK' || response?.success) {
          // Başarılı olduğunda sayfayı yenile veya event emit et
          this.$emit('subscription-activated', response.data)

          // Sayfayı yenile
          setTimeout(() => {
            window.location.reload()
          }, 1000)
        } else {
          throw new Error(
            response?.message || 'Abonelik ile aktif etme işlemi başarısız oldu'
          )
        }
      } catch (error) {
        console.error('Abonelik ile aktif etme hatası:', error)
        alert(
          error?.response?.data?.message ||
            error?.message ||
            'Bir hata oluştu. Lütfen tekrar deneyin.'
        )
      } finally {
        this.isLoading = false
      }
    },
  },
}
